import { BehaviorSubject } from 'rxjs';
import { ChangeDetectionStrategy, Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploaderComponent implements OnInit {

  @Input()
  set options(options: string[]) {
    if (options?.length) {
      this.showSelectedButtons(options);
    } else {
      this.showAllButtons();
    }
  }

  @Input() multiple = true;

  showCamera$ = new BehaviorSubject(true);
  showGallery$ = new BehaviorSubject(true);

  @Output() selectedFiles = new EventEmitter<File[]>();

  constructor() { }

  ngOnInit(): void {
  }

  private showSelectedButtons(options: string[]) {
    this.hideAllButtons();
    options.forEach(option => {
      switch (option) {
        case 'camera':
          this.showCamera$.next(true);
          break;
        case 'gallery':
          this.showGallery$.next(true);
          break;
        default:
          this.showAllButtons();
      }
    });
  }

  private hideAllButtons() {
    this.showCamera$.next(false);
    this.showGallery$.next(false);
  }

  private showAllButtons() {
    this.showCamera$.next(true);
    this.showGallery$.next(true);
  }

}
